/*
 * @Author       : Tom
 * @Date         : 2020-01-15 18:56:27
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-15 18:59:50
 * @FilePath     : /shanghuhoutai/src/lib/config.js
 * @Description  : 
 */
export const baseURL = process.env.VUE_APP_BASE_URL

//导出的url
export const exportURL = process.env.VUE_APP_EXPORT_URL

export const downloadURL = process.env.VUE_APP_DOWNLOAD_URL

// 引入图片的url
export const imgURL = process.env.VUE_APP_IMG_URL

export const STORE_ID = 1;